import React from "react";
import { connect } from "react-redux";
import * as echarts from "echarts";
import { statusPieEchart } from "../../Data/Charts";

class ServiceStatusPieChart extends React.Component {
  componentDidMount() {
    this.chartPlace();
  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.serviceByStatus !== this.props.serviceByStatus) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const {serviceByStatus} = this.props
    const pieChartData = serviceByStatus.map(item => ({
      value: item.total,
      name: item.type,
    }));
    const optionPieEchart = statusPieEchart(pieChartData);

    var chartDom = document.getElementById("ServiceStatusPieChart");
    var myChart = echarts.init(chartDom);
    var option;
    option = optionPieEchart;

    option && myChart.setOption(option);
  };
  render() {
    return (
      <div>
          <div className="header">
            <h2>Pasta Grafik</h2>
          </div>
          <div className="body">
            <div id="ServiceStatusPieChart" style={{ height: 300 }}></div>
            {/* <ReactEcharts
                        option={optionPieEchart}
                        opts={{renderer: 'svg'}} // use svg to render the chart.
                    /> */}
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceByStatus: state.analyticalReducer.serviceByStatus,
});

export default connect(mapStateToProps, {})(ServiceStatusPieChart);
